import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Employee } from 'app/Employees/domain/employee';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { Supplier } from '../domain/supplier';
import globalVariable from "../../../globalVariable/globalVariable.json";
import { LanguageService } from 'app/LanguageService/Language.Service';
import {
  buildSupplierCreatePayload,
  buildSupplierUpdatePayload,
} from 'common/services/supplier-update-payload.util';
@Component({
  selector: 'app-add-supplier',
  templateUrl: './add-supplier.component.html',
  styleUrls: ['./add-supplier.component.css']
})
export class AddSupplierComponent implements OnInit {
  supplierId: string;
  mode: string;
  loading: boolean = false;
  Supplier: Supplier;
  role: any;
  user: IUser;
  addProfileImage: any;
  dialogVisibility: boolean;
  uploadProfile: any;
  webcamImage: any = null;
  errorExempleNumber: any;
  isConfirmationBox: boolean;
  confirmationDialogVisible = false;
  confirmationDialogMessage = '';
  private pendingConfirmationAction: (() => void) | null = null;

  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private appServiceManager: AppServiceManager,
    public config: Configuration,
    private router: Router,

  ) {
    route.params.subscribe((params) => {
      this.supplierId = params["id"];
      if (this.supplierId === null || this.supplierId === undefined) {
        this.mode = "add";
      } else {
        this.mode = "edit";
      }
      this.breadcrumbService.setItems([
        { label: "Suppliers Listing", routerLink: ["/suppliers-listing"] },
        { label: "Supplier" },
      ]);
    })
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AddSupplierComponent", label);
  }
  ngOnInit(): void {
    this.role = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.Supplier = new Supplier();
    this.Supplier.gender = 'Male';
    this.Supplier.createdDate = new Date();
    this.Supplier.profile = this.config.Server + "assets/layout/images/avatarBoyImage.png";
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;
    this.addProfileImage = "Upload";
    this.isConfirmationBox = false;

    if (this.supplierId) {
      this.getSupplierById();
    }
  }

  getSupplierById() {
    const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
    if (!branchId || !this.supplierId) {
      return;
    }
    this.loading = true;
    this.appServiceManager.get(`branches/${branchId}/suppliers/${this.supplierId}`).subscribe(
      data => {
        if (data?.status === false) {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: data.error || 'Supplier not found' });
          return;
        }
        this.Supplier = data;
        this.Supplier.createdDate = new Date(this.Supplier.createdDate);
        this.loading = false;
      },
      error => {
        this.loading = false;
        alert(error);
      }
    );
  }

  captureImageDialogShow(type) {
    this.addProfileImage = type;
    this.dialogVisibility = true;
  }

  removeProfileImage() {
    this.uploadProfile = "";
    this.Supplier.profile = "";
    this.Supplier.profile = "assets/layout/images/avatarBoyImage.png";
  }

  hideAddProfileImage() {
    this.dialogVisibility = false;
  }

  handleImagefromNewProfile(webcamImage) {
    if (webcamImage) {
      this.uploadProfile = webcamImage;
      this.Supplier.profile = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
    }
  }

  onImgError(event) {
    event.target.src = 'assets/layout/images/avatarBoyImage.png'
  }

  changeProfile() {
    setTimeout(() => {
      if (this.Supplier.gender === "Female") {
        if (this.Supplier.profile.includes('avatarBoyImage.png')) {
          this.Supplier.profile =
            "assets/layout/images/avatarGirlImage.png";
        }
      }
      else if (this.Supplier.gender === "Male") {
        if (this.Supplier.profile.includes('avatarGirlImage.png')) {
          this.Supplier.profile = "assets/layout/images/avatarBoyImage.png";
        }
      }
    }, 300);
  }

  save() {
    this.openConfirmationDialog("Are you sure you want to save supplier?", () => {
        this.Supplier.company = this.user.company;
        this.Supplier.branch = this.user.branch;
        this.Supplier.createdBy = this.user._id;
        this.appServiceManager.post(
          `branches/${this.user.branch}/suppliers`,
          buildSupplierCreatePayload(this.Supplier, {
            company: this.user.company,
            branch: this.user.branch,
            createdBy: this.user._id,
          }),
        ).subscribe((res: any) => {
          if (res) {
            if(res.status == false) {
              this.messageService.clear();
              this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Supplier with this Details already Exists.' });
            }
            else {
              this.Supplier = res.Supplier;
              this.Supplier.createdDate = new Date(this.Supplier.createdDate);
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: res.error });
              this.router.navigateByUrl('supplier/' + this.Supplier._id);
            }
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });

    });

  }

  private openConfirmationDialog(message: string, action: () => void) {
    this.confirmationDialogMessage = message;
    this.pendingConfirmationAction = action;
    this.isConfirmationBox = true;
    this.confirmationDialogVisible = true;
  }

  cancelConfirmationDialog() {
    this.confirmationDialogVisible = false;
    this.pendingConfirmationAction = null;
    this.isConfirmationBox = false;
  }

  confirmConfirmationDialog() {
    const action = this.pendingConfirmationAction;
    this.cancelConfirmationDialog();
    action?.();
  }

  update() {
    this.openConfirmationDialog("Are you sure you want to update Supplier?", () => this.confirmSupplierUpdate());
  }

  confirmSupplierUpdate() {
    this.Supplier.company = this.user.company;
    this.Supplier.branch = this.user.branch;
    this.Supplier.modifiedBy = this.user._id;
    this.appServiceManager.patch(
      `branches/${this.user.branch}/suppliers/${this.Supplier._id}`,
      buildSupplierUpdatePayload(this.Supplier, this.user._id),
    ).subscribe((res: any) => {
      if (res) {
        this.Supplier = res.Supplier;
        this.Supplier.createdDate = new Date(this.Supplier.createdDate);
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Supplier Successfully Updated' });
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }






}
